import Angular from 'angular';
import Controller from "./scantag.controller";
import Template from './scantag.html';
import Vehicles from '../../services/vehicles.service';

export const ScanTagView = {
    template: Template,
    controller: Controller,
    controllerAs: '$ctrl'
};

export default Angular.module('view.scantag', [Vehicles.name]);



// WEBPACK FOOTER //
// ./src/modules/main/views/scantag/scantag.js